export default __webpack_public_path__ + "static/media/main_icon.bff61395.png";